import { useQuery } from '@tanstack/react-query'
import { useLocale } from 'next-intl'
import { ApiResponseBody, userApiClient } from '@/setup/api'

export type IGetCitiesQueryData = ApiResponseBody<'get', '/web/cities'>['data']

export enum CheckCityNameType {
    LOOSE = 'loose',
    STRICT = 'strict',
}

export type IGetCitiesQueryParams = {
    checkType?: CheckCityNameType
    name?: string
}

export const getCitiesQueryOptions = (params: IGetCitiesQueryParams, locale: string) =>
    userApiClient.queryOptions('get', '/web/cities', {
        params: { query: { name: params.name, checkType: params.checkType } },
        headers: { 'accept-language': locale },
    })

export function useGetCitiesQuery(params: IGetCitiesQueryParams) {
    const locale = useLocale()

    return useQuery(getCitiesQueryOptions(params, locale))
}
